
import ProfileApi from '../../api/ProfileApi';


export function changePasswordClearResponse() {
  return {
    type: 'CHANGE_PASSWORD_CLEAR_RESPONSE'
  };
}

/** Change Password **/
export const changePassword = (oldPassword, newPassword) => ({
    type: 'CHANGE_PASSWORD',
    payload: ProfileApi.changePassword(oldPassword, newPassword)
});



// WEBPACK FOOTER //
// ./src/features/profile/actions.js